import { createI18n } from "vue-i18n";
import { messages } from "@/lang/messages/index";
import { datetimeFormats } from "@/lang/dateTimeFormats/index";
import axios from "axios";

export const i18n = createI18n({
  legacy: false,
  locale: "fr",
  fallbackLocale: "fr",
  silentFallbackWarn: true,
  missingWarn: false,
  fallbackWarn: false,
  messages,
  datetimeFormats,
  warnHtmlMessage: false,
});
// TODO: commented as it's never imported and breaks vite build, remove if not needed
// const loadedLanguages = ["fr"]; // our default language that is prelaoded

// const langToBCP47 = {
//   fr: "fr-FR",
//   en: "en-US",
// };

// export const getLocaleBCPTag = () => {
//   if (!i18n || !langToBCP47[i18n.global.locale]) {
//     return "en-US";
//   }
//   return langToBCP47[i18n.global.locale];
// };

export const setI18nLanguage = (lang) => {
  i18n.global.locale.value = lang;
  axios.defaults.headers.common["Accept-Language"] = lang;
  document.querySelector("html").setAttribute("lang", lang);
  return lang;
};

// export const loadLanguageAsync = (lang) => {
//   if (i18n.global.locale !== lang) {
//     if (!loadedLanguages.includes(lang)) {
//       return import(
//         /* webpackChunkName: "lang-[request]" */ `@/lang/messages/${lang}`
//       ).then((msgs) => {
//         i18n.global.setLocaleMessage(lang, msgs.default);
//         loadedLanguages.push(lang);
//         return setI18nLanguage(lang);
//       });
//     }
//     return Promise.resolve(setI18nLanguage(lang));
//   }
//   return Promise.resolve(lang);
// };
